import { useQuery } from 'react-query';
import { subscriptionsServices } from '@services';
import { QUERY_KEYS } from 'constants/queryKeys';
import { showError } from '@utils';
import { useEffect } from 'react';
import { handleSubscriptionBundlesData } from './utils';

export const useSubscriptionBundles = (subscriptionId) => {
  const {
    data: bundlesData,
    isLoading: bundlesLoading,
    error: bundlesError,
    refetch: refetchBundles,
  } = useQuery(
    [QUERY_KEYS.GET_SUBSCRIPTION_BUNDLES_KEY, subscriptionId],
    () => subscriptionsServices.getSubscriptionBundles(subscriptionId),
    {
      enabled: !!subscriptionId,
    }
  );

  const bundles = handleSubscriptionBundlesData(bundlesData?.data || []);

  const {
    data: bundlesConfigData,
    isLoading: bundlesConfigLoading,
    error: bundlesConfigError,
  } = useQuery(
    [QUERY_KEYS.GET_SUBSCRIPTION_BUNDLES_CONFIG_KEY, subscriptionId],
    () => subscriptionsServices.getSubscriptionBundlesConfig(subscriptionId),
    {
      enabled: !!subscriptionId,
    }
  );

  const bundlesConfig = bundlesConfigData?.data || {};

  useEffect(() => {
    if (bundlesError) {
      showError(bundlesError?.error);
    }
  }, [bundlesError]);

  useEffect(() => {
    if (bundlesConfigError) {
      showError(bundlesConfigError?.error);
    }
  }, [bundlesConfigError]);

  return {
    bundles,
    bundlesLoading,
    bundlesConfig,
    bundlesConfigLoading,
    refetchBundles,
  };
};
